import { useContext } from "react";

import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { Loader } from "@jti/core-components/components/Loader";
import { FormattedPrice } from "@jti/ui/components/FormattedPrice";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { PriceTiersContext } from "@product-details/providers/PriceTiersContext";

import "./ProductMultiplier.scss";

const ProductMultiplierHeader = ({
  handleKeyDown,
  toggleDropdown,
}: {
  handleKeyDown: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  toggleDropdown: () => void;
}) => {
  const { __ } = useTranslations();
  const { selectedPriceTier } = useContext(PriceTiersContext);

  if (!selectedPriceTier) {
    return <Loader data-testid="productMultiplierLoader" />;
  }

  const { quantity, final_price, total_price, label } = selectedPriceTier;
  const priceToDisplay = total_price ?? final_price;
  return (
    <button
      data-testid="product-multiplier-header"
      className={"product-multiplier__header"}
      onKeyDown={handleKeyDown}
      onClick={toggleDropdown}
    >
      <div className={"product-multiplier__header-title"}>
        <span className={"product-multiplier__header-title-label"}>
          {quantity} {label || __("product.label.packs")}
        </span>{" "}
        <span className={"product-multiplier__header-title-label"}>
          (<FormattedPrice {...priceToDisplay} />)
        </span>
      </div>
      <div className={"product-multiplier__header-icon"}>
        <ChevronDownIcon />
      </div>
    </button>
  );
};

export default ProductMultiplierHeader;
